import Index from '../views/archive/Index.vue'

export default [
    {
        path: '/archive',
        name: 'archive',
        component: Index,
        meta: { title: 'Archiv' }
    },
    {
        path: '/archive/index',
        redirect: '/archive'
    }

]
